import VueI18n from 'vue-i18n'

import EnElementLang from 'element-ui/lib/locale/lang/en'
import ZhCNElementLang from 'element-ui/lib/locale/lang/zh-CN'
import ZhTWElementLang from 'element-ui/lib/locale/lang/zh-TW'
import JPElementLang from 'element-ui/lib/locale/lang/ja'
import ElementLocale from 'element-ui/lib/locale'

import EnLang from '@/js/lang/en'
import ZhCNLang from '@/js/lang/zh'
import ZHTWLang from '@/js/lang/tw'
import JPLang from '@/js/lang/jp'

import * as tokenProcess from '@/js/tokenProcess'

export const LANG_EN = 'en'
export const LANG_ZHCN = 'zh'
export const LANG_ZHTW = 'tw'
export const LANG_JP = 'jp'
export let i18n

const messages = {
  [LANG_EN]: {
    ...EnLang,
    ...EnElementLang
  },
  [LANG_ZHCN]: {
    ...ZhCNLang,
    ...ZhCNElementLang
  },
  [LANG_ZHTW]: {
    ...ZHTWLang,
    ...ZhTWElementLang
  },
  [LANG_JP]: {
    ...JPLang,
    ...JPElementLang
  }
}

// export let nvgLang = getNvgLang()
const nvgLangStr = getNvgLang()
// let curLocal = getNvgLang()
let curLocal = nvgLangStr

export let nvgLang = nvgLangStr

export function getNvgLang () {
  // let nvgLang = navigator.language || (navigator.userLanguage && navigator.userLanguage.replace(/-[a-z]{2}$/, String.prototype.toUpperCase)) || 'en-US'
  // return nvgLang.substr(0, 2)
  const scLang = localStorage.getItem('scLang')
  console.log('scLang', scLang)
  if (scLang === LANG_ZHCN || scLang === LANG_ZHTW || scLang === LANG_JP || scLang === LANG_EN) {
    return scLang
  }
  let langStr = (navigator.language || navigator.browserLanguage).toLowerCase()
  if (langStr === 'zh-cn' || langStr === 'zh') {
    return LANG_ZHCN
  } else if (langStr.substr(0, 2) === 'zh') {
    return LANG_ZHTW
  } else if (langStr.substr(0, 2) === 'ja') {
    return LANG_JP
  } else {
    return LANG_EN
  }
}

export function setLang (lang) {
  if (lang !== LANG_ZHCN && lang !== LANG_ZHTW && lang !== LANG_JP && lang !== LANG_EN) {
    lang = LANG_EN
  }
  curLocal = lang
  i18n.locale = curLocal
  localStorage.setItem('scLang', curLocal)
  tokenProcess.setCookie('language', curLocal, 1)
}

export function getLang () {
  return curLocal
}

export function useI18n (Vue) {
  Vue.use(VueI18n)

  i18n = new VueI18n({
    locale: localStorage.getItem('scLang') || `${curLocal}`,
    messages
  })

  ElementLocale.i18n((key, value) => i18n.t(key, value))
}



// WEBPACK FOOTER //
// ./src/js/lang/lang.js